import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

/**
 * @type {boolean}
 * @returns {Object} {{
 * value: boolean,
 * setValue: function,
 * setTrue: function,
 * setFalse: function,
 * toggle: function
 * }}
 */
export function useBoolean(defaultValue = false) {
  const [value, setValue] = useState(!!defaultValue);

  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue(x => !x), []);

  return {
    value,
    setValue,
    setTrue,
    setFalse,
    toggle,
  };
}

useBoolean.propTypes = {
  defaultValue: PropTypes.bool,
};
